import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, combineLatest, takeUntil } from 'rxjs';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

import { AuthService, BRAND_CONFIG, NotificationService } from '@shared/services';
import { ErrorUtils } from '@shared/utils';

import { fromAuth } from '../../store';

@Component({
  selector: 'app-maintenance-page',
  imports: [RktIconComponent, RktButtonDirective, AsyncPipe],
  templateUrl: './maintenance-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './maintenance-page.component.scss',
})
export class MaintenancePageComponent implements OnInit {
  store = inject(Store);
  router = inject(Router);
  authService = inject(AuthService);
  notificationService = inject(NotificationService);
  brand = inject(BRAND_CONFIG);

  isAuthenticated$ = this.store.select(fromAuth.selectLoggedIn);

  isFirstStatusCall = true;

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.onBackToDashboardBtnClick();
  }

  onBackToDashboardBtnClick(): void {
    combineLatest([this.store.select(fromAuth.selectLoggedIn), this.authService.getMaintenanceInfo()])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ([authenticated]) => {
          if (!authenticated) {
            this.router.navigateByUrl('/');
          } else {
            this.router.navigateByUrl('/app/dashboard');
          }
        },
        error: (error) => {
          if (!this.isFirstStatusCall) {
            this.notificationService.displayError('System Maintenance in Progress', 'Error');
            ErrorUtils.catchError('System Maintenance in Progress', error);
          }
          this.isFirstStatusCall = false;
        },
      });
  }
}
